var render = function render(){
  var _vm$selectedCustomer;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "drawer-wrapper"
  }, [_c('CustomerSearchSidebar'), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectedCustomer,
      expression: "selectedCustomer"
    }],
    staticClass: "customer-detail-wrap"
  }, [_c('h1', {
    staticClass: "customer-title"
  }, [_vm._v(_vm._s((_vm$selectedCustomer = _vm.selectedCustomer) === null || _vm$selectedCustomer === void 0 ? void 0 : _vm$selectedCustomer.name))]), _c('CustomerAnalyzeDetailPanel')], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }